/* Up! Up! Up! Down! – Landingpage. Texte stehen im HTML (Weglot), hier nur Umschalten und Zahlen. */
(function () {
  'use strict';

  function init(root) {
    if (!root || root.dataset.uudReady) return;
    root.dataset.uudReady = '1';
    var lang = (document.documentElement.lang || 'de').slice(0, 2);
    var nf = new Intl.NumberFormat(lang === 'de' ? 'de-DE' : lang);
    var $ = function (sel, el) { return (el || root).querySelector(sel); };
    var $$ = function (sel, el) { return Array.prototype.slice.call((el || root).querySelectorAll(sel)); };
    var DAY = 86400000;

    // Zahlen in Sprache der Seite
    $$('[data-uud-num]').forEach(function (el) {
      var n = parseFloat(el.getAttribute('data-uud-num'));
      if (!isNaN(n)) el.textContent = nf.format(n);
    });

    // --- Rundfahrten / Trikot --------------------------------------------
    function parseDate(str, endOfDay) {
      var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(str || '').trim());
      if (!m) return null;
      var d = new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
      if (endOfDay) d = new Date(d.getTime() + DAY - 1);
      return d.getTime();
    }
    var ids = ['giro', 'tour', 'vuelta'];
    var tours = {};
    ids.forEach(function (k) {
      tours[k] = { start: parseDate(root.dataset[k + 'Start']), end: parseDate(root.dataset[k + 'End'], true) };
    });
    var now = Date.now();
    var running = null;
    var next = null;
    ids.forEach(function (k) {
      var t = tours[k];
      if (t.start == null || t.end == null) return;
      if (now >= t.start && now <= t.end) running = k;
      if (now < t.start && (next == null || t.start < tours[next].start)) next = k;
    });

    function setTour(k) {
      $$('[data-uud-tour]').forEach(function (b) {
        var on = b.getAttribute('data-uud-tour') === k;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      $$('[data-uud-show]').forEach(function (el) { el.hidden = el.getAttribute('data-uud-show') !== k; });
      var hero = $('[data-uud-hero]');
      if (hero && root.dataset['hero' + k.charAt(0).toUpperCase() + k.slice(1)]) {
        hero.src = root.dataset['hero' + k.charAt(0).toUpperCase() + k.slice(1)];
      }
      var rider = root.dataset['rider' + k.charAt(0).toUpperCase() + k.slice(1)];
      if (rider) {
        $$('[data-uud-rider]').forEach(function (img) { img.setAttribute('href', rider); });
        $$('[data-uud-rider-img]').forEach(function (img) { img.src = rider; });
      }
    }
    $$('[data-uud-tour]').forEach(function (b) {
      b.addEventListener('click', function () { setTour(b.getAttribute('data-uud-tour')); });
    });
    if (running) setTour(running);

    // Karten: Start in X Tagen / läuft / vorbei
    $$('[data-uud-tcard]').forEach(function (card) {
      var k = card.getAttribute('data-uud-tcard');
      var t = tours[k];
      if (t.start == null) return;
      var state = now < t.start ? 'before' : (now <= t.end ? 'live' : 'after');
      $$('[data-uud-when]', card).forEach(function (el) { el.hidden = el.getAttribute('data-uud-when') !== state; });
      var d = $('[data-uud-days]', card);
      if (d) d.textContent = nf.format(Math.ceil((t.start - now) / DAY));
    });

    // Countdown
    var count = $('[data-uud-count]');
    if (count) {
      var key = 'over';
      var days = 0;
      if (running) { key = running + '-live'; days = Math.max(1, Math.ceil((tours[running].end - now) / DAY)); }
      else if (next) { key = next + '-next'; days = Math.ceil((tours[next].start - now) / DAY); }
      $$('[data-uud-count-text]', count).forEach(function (el) { el.hidden = el.getAttribute('data-uud-count-text') !== key; });
      var cd = $('[data-uud-count-days]', count);
      if (key === 'over') { if (cd) cd.hidden = true; } else if (cd) { cd.textContent = nf.format(days); }
    }

    // --- Etikett-Karten ------------------------------------------------------
    $$('[data-uud-card]').forEach(function (card) {
      var btn = $('[data-uud-toggle]', card);
      var panel = btn && document.getElementById(btn.getAttribute('aria-controls'));
      if (!btn || !panel) return;
      btn.addEventListener('click', function () {
        var open = panel.hidden;
        panel.hidden = !open;
        card.classList.toggle('is-open', open);
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        $('[data-uud-label-closed]', btn).hidden = open;
        $('[data-uud-label-open]', btn).hidden = !open;
      });
    });

    // --- Espresso / Filter ---------------------------------------------------
    $$('[data-uud-bag]').forEach(function (b) {
      b.addEventListener('click', function () {
        var k = b.getAttribute('data-uud-bag');
        $$('[data-uud-bag]').forEach(function (x) {
          var on = x === b;
          x.classList.toggle('is-on', on);
          x.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        $$('[data-uud-bag-panel]').forEach(function (p) { p.hidden = p.getAttribute('data-uud-bag-panel') !== k; });
      });
    });

    // --- Dial-in-Trainer -----------------------------------------------------
    var cogs = $$('[data-uud-gear]');
    var pull = $('[data-uud-pull]');
    var timerEl = $('[data-uud-timer]');
    var gramsEl = $('[data-uud-grams]');
    var cup = $('[data-uud-cup]');
    var cupFill = cup && cup.querySelector('i');
    var taste = $('[data-uud-taste]');
    var yieldG = parseFloat(root.dataset.shotYield) || 40;
    var okMin = parseFloat(root.dataset.shotMin) || 30;
    var okMax = parseFloat(root.dataset.shotMax) || 40;
    var gear = 1;
    var raf = null;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function pullLabel(k) { $$('[data-uud-pull-label]').forEach(function (el) { el.hidden = el.getAttribute('data-uud-pull-label') !== k; }); }
    function showVerdict(k, t) {
      $$('[data-uud-verdict]').forEach(function (el) {
        var on = el.getAttribute('data-uud-verdict') === k;
        el.hidden = !on;
        if (on) {
          $$('[data-uud-t]', el).forEach(function (s) { s.textContent = nf.format(t); });
          if (taste) taste.style.left = (el.getAttribute('data-taste') || 50) + '%';
        }
      });
      if (k === 'ready' && taste) taste.style.left = '50%';
    }
    function setShot(t, target) {
      var g = Math.min(yieldG, (t / target) * yieldG);
      if (timerEl) timerEl.textContent = nf.format(Math.floor(t));
      if (gramsEl) gramsEl.textContent = nf.format(Math.round(g * 10) / 10);
      if (cupFill) cupFill.style.width = Math.round((g / yieldG) * 100) + '%';
      if (cup) cup.setAttribute('aria-valuenow', String(Math.round(g)));
    }
    function verdictKey(t) {
      if (t < 25) return 'fast';
      if (t < okMin) return 'almost';
      if (t <= okMax) return 'ok';
      if (t <= okMax + 6) return 'tough';
      return 'slow';
    }
    function reset() {
      if (raf) cancelAnimationFrame(raf);
      raf = null;
      if (pull) pull.disabled = false;
      setShot(0, 1);
      showVerdict('ready', 0);
      pullLabel('ready');
    }
    cogs.forEach(function (c) {
      c.addEventListener('click', function () {
        gear = Number(c.getAttribute('data-uud-gear'));
        cogs.forEach(function (x) {
          var on = x === c;
          x.classList.toggle('is-on', on);
          x.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        reset();
      });
    });
    if (pull) {
      pull.addEventListener('click', function () {
        var c = cogs[gear];
        var target = c ? Number(c.getAttribute('data-time')) : 30;
        if (raf) cancelAnimationFrame(raf);
        if (reduce) { setShot(target, target); showVerdict(verdictKey(target), target); pullLabel('again'); return; }
        pull.disabled = true;
        pullLabel('running');
        showVerdict('ready', 0);
        var started = performance.now();
        var speed = 10;
        (function step(ts) {
          var t = ((ts - started) / 1000) * speed;
          if (t >= target) {
            setShot(target, target);
            showVerdict(verdictKey(target), target);
            pullLabel('again');
            pull.disabled = false;
            raf = null;
            return;
          }
          setShot(t, target);
          raf = requestAnimationFrame(step);
        })(started);
      });
    }

    // --- Filter-Rechner ------------------------------------------------------
    var cups = $('[data-uud-cups]');
    var ratio = parseFloat(String(root.dataset.filterRatio || '16.5').replace(',', '.')) || 16.5;
    var cupMl = parseFloat(root.dataset.cupMl) || 250;
    function calc() {
      var n = Math.max(1, Math.min(12, parseInt(cups.value, 10) || 1));
      var water = n * cupMl;
      var fg = $('[data-uud-fgrams]');
      var fw = $('[data-uud-fwater]');
      if (fg) fg.textContent = nf.format(Math.round(water / ratio));
      if (fw) fw.textContent = nf.format(water);
    }
    if (cups) { cups.addEventListener('input', calc); calc(); }

    // --- Pässe ---------------------------------------------------------------
    $$('[data-uud-pass]').forEach(function (b) {
      b.addEventListener('click', function () {
        var k = b.getAttribute('data-uud-pass');
        $$('[data-uud-pass]').forEach(function (x) {
          var on = x === b;
          x.classList.toggle('is-on', on);
          x.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        $$('[data-uud-pass-info]').forEach(function (el) { el.hidden = el.getAttribute('data-uud-pass-info') !== k; });
      });
    });

    // --- Kaufbox -------------------------------------------------------------
    var buy = $('[data-uud-buy]');
    if (buy) {
      var addBtn = $('[data-uud-add]', buy);
      var err = $('[data-uud-add-error]', buy);
      var bagImg = $('[data-uud-bag-img]', buy);
      function pickVariant(btn) {
        $$('[data-uud-variant]', buy).forEach(function (x) {
          var on = x === btn;
          x.classList.toggle('is-on', on);
          x.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        $('[data-uud-price]', buy).textContent = btn.getAttribute('data-price');
        $('[data-uud-unit]', buy).textContent = btn.getAttribute('data-unit');
        if (addBtn) addBtn.setAttribute('data-variant', btn.getAttribute('data-uud-variant'));
      }
      $$('[data-uud-roast]', buy).forEach(function (r) {
        r.addEventListener('click', function () {
          var roast = r.getAttribute('data-uud-roast');
          $$('[data-uud-roast]', buy).forEach(function (x) {
            var on = x === r;
            x.classList.toggle('is-on', on);
            x.setAttribute('aria-pressed', on ? 'true' : 'false');
          });
          var current = $('[data-uud-variant].is-on', buy);
          var currentLabel = current ? current.textContent.trim() : '';
          var match = null;
          var firstAvail = null;
          $$('[data-uud-variant]', buy).forEach(function (v) {
            var show = v.getAttribute('data-roast') === roast;
            v.hidden = !show;
            if (show && !v.disabled) {
              if (!firstAvail) firstAvail = v;
              if (v.textContent.trim() === currentLabel) match = v;
            }
          });
          if (match || firstAvail) pickVariant(match || firstAvail);
          if (bagImg) bagImg.src = roast === 'filter' ? buy.dataset.bagFilter : buy.dataset.bagEspresso;
        });
      });
      $$('[data-uud-variant]', buy).forEach(function (v) {
        v.addEventListener('click', function () { if (!v.disabled) pickVariant(v); });
      });
      if (addBtn) {
        addBtn.addEventListener('click', function () {
          var id = Number(addBtn.getAttribute('data-variant'));
          if (!id) return;
          addBtn.disabled = true;
          if (err) err.hidden = true;
          var root_url = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          fetch(root_url + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
          }).then(function (r) {
            if (!r.ok) throw new Error('cart');
            window.location.href = root_url + 'cart';
          }).catch(function () {
            addBtn.disabled = false;
            if (err) err.hidden = false;
          });
        });
      }
    }
  }

  function boot() { document.querySelectorAll('[data-uud]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target && e.target.querySelector && e.target.querySelector('[data-uud]');
    if (el) init(el);
  });
})();
